import Swal from "sweetalert2";

const defaultCustomClass = {
  popup: "swal-modern-popup",
  title: "swal-modern-title",
  htmlContainer: "swal-modern-html",
  actions: "swal-modern-actions",
  confirmButton: "btn secondary-btn swal-modern-confirm",
  cancelButton: "btn secondary-light-btn swal-modern-cancel",
};

/**
 * 🔹 Base function to show any type of alert
 */
const showAlert = (firstParam = {}, secondParam = "") => {
  let config = {};
  if (typeof firstParam === "string") {
    config = {
      title: firstParam,
      text: secondParam,
    };
  } else if (typeof firstParam === "object" && firstParam !== null) {
    config = { ...firstParam };
  }

  const {
    title = "",
    text = "",
    html = "",
    icon = "info", // "success", "error", "warning", "info", "question"
    timer = 0,
    showConfirmButton = true,
    confirmButtonText = "OK",
    customClass = {},
    ...options
  } = config;

  return Swal.fire({
    title,
    text,
    html,
    icon,
    timer,
    showConfirmButton,
    confirmButtonText,
    buttonsStyling: false,
    customClass: {
      ...defaultCustomClass,
      ...customClass,
    },
    ...options,
  });
};

/**
 * 🔹 Confirmation alert (returns a promise that resolves to true/false)
 */
const confirm = async (firstParam = {}, secondParam = "") => {
  let config = {};
  if (typeof firstParam === "string") {
    config = {
      title: firstParam,
      text: secondParam,
    };
  } else if (typeof firstParam === "object" && firstParam !== null) {
    config = { ...firstParam };
  }

  const {
    title = "Are you sure?",
    text = "Do you want to continue?",
    icon = "question",
    iconHtml,
    confirmButtonText = "Yes",
    cancelButtonText = "No",
    reverseButtons = true,
    showCancelButton = true,
    customClass = {},
    ...options
  } = config;

  const result = await Swal.fire({
    title,
    text,
    icon,
    ...(iconHtml ? { iconHtml } : {}),
    showCancelButton,
    cancelButtonText,
    confirmButtonText,
    reverseButtons,
    buttonsStyling: false,
    customClass: {
      ...defaultCustomClass,
      ...customClass,
    },
    ...options,
  });
  return result.isConfirmed;
};

/**
 * 🔹 Shortcut alert types
 */
const success = (title = "Success", text = "") =>
  showAlert({ icon: "success", title, text, confirmButtonText: "OK" });

const error = (title = "Error", text = "") =>
  showAlert({ icon: "error", title, text, confirmButtonText: "OK" });

const info = (title = "Info", text = "") =>
  showAlert({ icon: "info", title, text, confirmButtonText: "OK" });

const warning = (title = "Warning", text = "") =>
  showAlert({ icon: "warning", title, text, confirmButtonText: "OK" });

/**
 * 🔹 Export single common service
 */
export const SwalService = {
  showAlert,
  confirm,
  success,
  error,
  info,
  warning,
};
